import MuiTextField from '@mui/material/TextField';
import { TextFieldProps } from '../input.interface';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import { useId } from 'react';
import { DEFAULT_BORDER_RADIUS } from 'src/theme/constants';

const StyledTextField = styled(MuiTextField)(({ theme: { palette } }) => ({
  '& fieldset': {
    borderRadius: DEFAULT_BORDER_RADIUS,
  },
  '& .Mui-error': {
    color: `${palette.error.contrastText} !important`,
    border: 'none',
    '& fieldset': {
      borderColor: `${palette.error.contrastText} !important`,
    },
  },
}));
export const TextField: React.FC<TextFieldProps> = ({
  label,
  fullWidth,
  onChange,
  value,
  sx,
  type = 'search',
  showSearchIcon = false,
  ...props
}) => {
  const inputId = useId();
  return (
    <InputWrapper label={label} fullWidth={fullWidth} htmlFor={inputId}>
      <StyledTextField
        value={value}
        onChange={onChange}
        sx={sx}
        id={inputId}
        type={type}
        {...props}
        slotProps={{
          ...(showSearchIcon && {
            input: {
              startAdornment: (
                <InputAdornment
                  position="start"
                  sx={{
                    ml: 12,
                  }}
                >
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
              //@ts-expect-error -- the type for props.slotProps.input seems to be narrowed too much and startAdornment is dropped off
              ...props.slotProps?.input?.startAdornment,
            },
            ...props.slotProps?.input,
          }),
          ...props.slotProps,
        }}
      />
    </InputWrapper>
  );
};
